import request from '@/utils/request'

// 获取主页
export function getIndex(data) {
  return request({
    method: 'post',
    path: 'index/index',
    data
  })
}
